import React, { memo } from 'react'
import { IconButton } from '@material-ui/core'

export default memo(({ icon, ...props }) => <IconButton {...props}>{icon}</IconButton>)
